<template>
    <div class="dropdown column-visible">
        <button 
        class="btn btn-default dropdown-toggle"
        type="button"
        id="dropdownMenu1"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true">
            <font-awesome-icon :icon="'columns'" />
            <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
            <li v-for="field in fieldsToShowOnMenu">
                <a v-on:click.stop.prevent="changeVisibility(field)">
                    {{ field.title }}
                    <font-awesome-icon v-if="field.visible" :icon="'check-double'"/>
                    <font-awesome-icon v-else="field.visible" :icon="'times'"></font-awesome-icon>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  props: {
    fields: Array
  },
  data() {
    return {
      changedFields: {}
    }
  },
  computed: {
    normalizedFields: function() {
      let visibleFields = this.fields.map(field =>
        !('visible' in field) || field.visible
          ? ((field.visible = true), field)
          : ((field.visible = false), field)
      )
      return visibleFields.map(field =>
        !('showOnVisibilityMenu' in field) || field.showOnVisibilityMenu
          ? ((field.showOnVisibilityMenu = true), field)
          : ((field.showOnVisibilityMenu = false), field)
      )
    },
    fieldsToShowOnMenu: function() {
      if (!this.normalizedFields) return []

      return this.normalizedFields
        ? this.normalizedFields.filter(field =>
            field.showOnVisibilityMenu ? true : false
          )
        : []
    }
  },
  methods: {
    changeVisibility(event) {
      let checked = !event.visible
      let fieldName = event.name

      this.changedFields = this.normalizedFields.map(field =>
        field.hasOwnProperty('name') && field.name == fieldName
          ? ((field.visible = checked), field)
          : field
      )
      this.$emit('update:fields', this.changedFields)
      this.$events.emit('column-visibility:changed')
    }
  }
}
</script>

<style scoped>
.column-visible {
  margin-right: 10px;
}
.fa-check-double {
  color: #00615c;
}

.fa-times {
  color: #990000;
}
ul.dropdown-menu > li > a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/vuetable2-column-visibility/index.vue